import { Info } from 'lucide-react';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';

export function InfoTooltip({ label, title, children, side = 'top', triggerClassName = '' }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={label}
          className={`inline-flex items-center justify-center w-5 h-5 rounded-full text-brand-muted hover:text-brand-blue-light transition-colors flex-shrink-0 ${triggerClassName}`}
          style={{ background: 'rgba(var(--c-purple-rgb),0.12)', border: '1px solid rgba(var(--c-purple-rgb),0.28)' }}
        >
          <Info size={12} />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side={side}
        sideOffset={8}
        className="w-80 max-w-[calc(100vw-2rem)] p-4 rounded-xl bg-brand-charcoal text-left shadow-[0_8px_32px_rgba(0,0,0,0.35)]"
        style={{ border: '1px solid var(--brand-glass-border)' }}
      >
        <p className="text-sm font-bold text-brand-white mb-2">{title}</p>
        <div className="text-xs text-brand-muted leading-relaxed space-y-1.5">{children}</div>
      </TooltipContent>
    </Tooltip>
  );
}

export function TooltipBullet({ children }) {
  return (
    <li className="flex items-start gap-2">
      <span className="mt-1.5 w-1 h-1 rounded-full flex-shrink-0" style={{ background: 'var(--c-purple-400)' }} />
      <span>{children}</span>
    </li>
  );
}
